import platform from '@propertypal/shared/src/utils/platform';
import Link from 'next/link';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  color: ${({ theme }) => theme.textDark};
  text-align: center;
  ${({ theme }) =>
    platform.select('box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);', `border: 1px solid ${theme.backgroundLight};`)}
`;

export const TextBox = styled.div`
  padding: 15px;
  flex: 1;

  h2 {
    font-size: 21px;
  }

  p {
    font-size: 16px;
    color: ${({ theme }) => theme.backgroundMid};
  }

  a {
    color: ${({ theme }) => theme.primary};

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const AgentLogo = styled.img`
  margin: 0 auto 15px;
  display: block;
  height: 36px;
`;

export const BoxRow = styled.div`
  display: flex;
  flex-direction: row;
  border-top: 1px solid ${({ theme }) => theme.keyline};
  border-bottom: 1px solid ${({ theme }) => theme.keyline};
`;

export const BoxColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  height: 80px;
  padding: 0 10px;

  h3 {
    margin-top: 5px;
    font-size: 16px;
  }

  &:first-child {
    border-right: 1px solid ${({ theme }) => theme.keyline};
  }
`;

export const SearchLink = styled(Link)`
  display: block;
  margin: 15px 0;
  font-size: 16px;
  color: ${({ theme }) => theme.primary};
  vertical-align: center;

  &:hover {
    text-decoration: underline;
  }
`;
